import type { SxProps, Theme } from '@mui/material';

export const container: SxProps<Theme> = {
  position: 'fixed',
  bottom: 0,
  left: (theme) => (theme.breakpoints.up('md') ? 256 : 0), // Use the actual NAVIGATION_DRAWER_WIDTH value
  right: 0,
  zIndex: 1300,
};

export const card: SxProps<Theme> = {
  borderRadius: 0,
  backgroundColor: (theme) => theme.palette.background.paper,
  boxShadow: (theme) =>
    theme.palette.mode === 'light'
      ? '0px 1px 3px 0px rgba(16,30,36,0.08), 0px 1px 1px 0px rgba(16,30,36,0.10)'
      : theme.shadows[2],
};

export const cardContent: SxProps<Theme> = {
  py: 2,
  px: 3,
  '&:last-child': { pb: 2 },
};

export const mainContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
};

export const trackInfoContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  minWidth: 200,
};

export const artwork: SxProps<Theme> = {
  width: 48,
  height: 48,
  borderRadius: '4px',
  backgroundSize: 'cover',
  backgroundPosition: 'center',
};

export const trackTextContainer: SxProps<Theme> = {};

export const trackTitle: SxProps<Theme> = {
  fontWeight: 500,
};

export const controlsContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  mx: 2,
};

export const playButton: SxProps<Theme> = {
  color: 'text.primary',
  backgroundColor: 'rgba(179, 136, 255, 0.1)',
  '&:hover': {
    backgroundColor: 'rgba(179, 136, 255, 0.2)',
  },
};

export const progressContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 2,
  flexGrow: 1,
};

export const timeLabel: SxProps<Theme> = {
  minWidth: 35,
};

export const progressSlider: SxProps<Theme> = {
  color: '#b388ff',
  height: 4,
  '& .MuiSlider-thumb': {
    width: 12,
    height: 12,
    '&:hover, &.Mui-focusVisible': {
      boxShadow: '0px 0px 0px 8px rgba(179, 136, 255, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    backgroundColor: (theme) => theme.palette.divider,
  },
};

export const volumeContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  minWidth: 120,
};

export const volumeIcon: SxProps<Theme> = {
  color: 'text.secondary',
  fontSize: 20,
};

export const volumeSlider: SxProps<Theme> = {
  color: '#b388ff',
  height: 4,
  '& .MuiSlider-thumb': {
    width: 12,
    height: 12,
    '&:hover, &.Mui-focusVisible': {
      boxShadow: '0px 0px 0px 8px rgba(179, 136, 255, 0.16)',
    },
  },
  '& .MuiSlider-track': {
    border: 'none',
  },
  '& .MuiSlider-rail': {
    backgroundColor: (theme) => theme.palette.divider,
  },
};
